module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av15-f803edb75daf916a01d373980cdc8912.jpg";